import { isNative } from '../api/origin.ts';

/**
 * Whether this window is one somebody is actually looking at.
 *
 * Three decisions read it and all three have to agree, because any disagreement
 * between two of them is a message announced twice or not at all: the foreground
 * claim the server suppresses notifications by, the read receipt that clears the
 * badge, and whether an arriving message counts as unread at all.
 *
 * They used to differ by `document.hasFocus()` — the claim asked for it, the
 * receipt did not — and that gap was a real window rather than a nicety. Visible
 * but unfocused meant the server pushed a notification for a message this same
 * client had already marked read: a banner sitting in the shade beside a chat
 * list with nothing unread in it, which is exactly the symptom that reads as
 * «уведомления живут своей жизнью».
 *
 * `hasFocus` is consulted off-native only. It is there for a desktop, where
 * another window can cover this one without the page ever becoming hidden. A
 * phone has one window, so visibility is the whole answer there — and a
 * WebView's answer to `hasFocus` is not something to gate notifications on.
 */
export function isOnScreen(): boolean {
  if (typeof document === 'undefined') return false;
  if (document.visibilityState !== 'visible') return false;
  return isNative || document.hasFocus();
}
